export interface RepresentativeExampleTypes {
  title: string
  bodyCopy: string
  bodyCopyVariant: string
  descriptionList: { term: string; details: string }[]
}

export const representativeExample = {
  title: 'Personal Contract Purchase (PCP) representative example',
  bodyCopy: `Based on an on the road price of <strong>£31,723.92</strong>, with a <strong>£2,800.00</strong> customer deposit, plus a <strong>£1,060.00</strong> finance deposit contribution and borrowing <strong>£27,863.92</strong> at a representative APR of <strong>3.5%</strong> and the following:`,
  bodyCopyVariant: `Based on an on the road price of £31,723.92, with a £2,800.00 customer deposit, plus a £1,060.00 finance deposit contribution and borrowing £27,863.92 at a representative APR of 3.5%. 49 monthly payments of £325.00. Fixed rate of interest per annum 1.8%. Optional final payment £15,318.00. Amount of interest £3,054.08. Total amount payable £34,778.00. Annual mileage limit 6,000 miles. Excess mileage charge 14.9p per mile. On the road price includes a retailer discount of £1,591.08.`,
  descriptionList: [
    {
      term: '49 monthly payments of',
      details: '£325.00',
    },
    {
      term: 'Fixed rate of interest per annum',
      details: '1.8%',
    },
    {
      term: 'Optional final payment',
      details: '£15,318.00',
    },
    {
      term: 'Amount of interest',
      details: '£3,054.08',
    },
    {
      term: 'Total amount payable',
      details: '£34,778.00',
    },
    {
      term: 'Annual mileage limit',
      details: '6,000 miles',
    },
    {
      term: 'Excess mileage charge',
      details: '14.9p per mile',
    },
    {
      term: 'Retailer discount',
      details: '£1,591.08',
    },
  ],
}

export const findVehicle = {
  title: 'Browse our cars',
  description:
    'Compare thousands of cars and find the one that’s right for you. Whether its by model, brand or vehicle type, cinch makes it simple and faff free.',
  noResults: {
    makeAndModelHeading: "Sorry, we can't find that car",
    makeAndModel:
      "We can't track down that make or model - it may be unavailable or reserved. Try checking back with us shortly to see if it's back in stock.",
    makeAndModelClearFiltersButton: 'Search all cars',
    makeAndModelSearchText:
      "Alternatively, as we've got loads of delivery options, maybe hit the button or try",
    generic: 'We searched high and low, but nothing matched your search.',
    genericHeading: "Sorry, we couldn't find you a car",
    genericSearchText: 'Maybe edit/clear your filters below or try',
    genericEditFiltersButton: 'Edit filters',
    genericClearFiltersButton: 'Clear filters',
  },
  representativeExample: representativeExample,
}
